var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: (_vm.prefixCls + "-panel " + _vm.prefixCls + "-panel-default")
  }, [_c('div', {
    class: (_vm.prefixCls + "-panel-heading")
  }, [_c('h4', {
    class: (_vm.prefixCls + "-panel-title")
  }, [_c('a', {
    on: {
      "click": function($event) {
        _vm.toggleIsOpen()
      }
    }
  }, [_vm._t("header", [_vm._v("\n            " + _vm._s(_vm.header) + "\n           ")])], 2)])]), _vm._v(" "), _c('n3-collapse-transition', [(_vm.open) ? _c('div', {
    class: (_vm.prefixCls + "-panel-collapse")
  }, [_c('div', {
    class: (_vm.prefixCls + "-panel-body")
  }, [_vm._t("default")], 2)]) : _vm._e()])], 1)
}
var staticRenderFns = []
render._withStripped = true
export default { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-0d7bcefe", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0d7bcefe"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/Accordion/n3Panel.vue
// module id = 601
// module chunks = 0 1